import { twApi } from '../api';
import {
  BulkUploadParams,
  CreateLoadConfig,
  LoadDocumentParams,
  LoadStatus,
  SearchLoadParams,
  getDeliveredColumnStatusesByRole,
  ButlerModel,
  EdiStopMessageUpdate
} from './load.model';

import { EdiDelayReasonCode } from '../../../components/TwEdiMessageUpdate/TwEdiDelayReasonList';

const loadApi = twApi.injectEndpoints({
  endpoints: (builder) => ({
    getCreateLoadConfig: builder.query<CreateLoadConfig[], void>({
      query: () => ({
        url: 'orders/expected-fields'
      }),
      transformResponse: (response: { data: CreateLoadConfig[] }) => {
        return response.data;
      }
    }),

    getExtractionConfigs: builder.query<ButlerModel[], void>({
      query: (args) => ({
        url: 'v3/extraction-configs',
        method: 'GET'
      }),
      transformResponse: (response: { data: ButlerModel[] }) => {
        return response.data;
      }
    }),

    qboCustomerSearch: builder.mutation<string | null, { customerId: string; divisionId: string }>({
      query: (data) => ({
        url: '/v3/invoices/qbo-customer-search',
        body: {
          customer_id: data.customerId,
          division_id: data.divisionId
        },
        method: 'POST'
      }),
      transformResponse: (response: { customer: { id: string } | null }) =>
        response.customer?.id ?? null
    }),
    addDocument: builder.mutation<
      number,
      {
        document: LoadDocumentParams;
        loadId: string;
        searchParams?: SearchLoadParams;
        query?: string;
      }
    >({
      query: (data) => {
        const formData = new FormData();

        formData.append('document', data.document.document);
        formData.append('type', data.document.type);
        formData.append('visibility', data.document.visibility ? 'true' : 'false');

        return {
          url: `/loads/${data.loadId}/documents`,
          formData: true,
          method: 'POST',
          body: formData
        };
      },

      transformResponse: (response: number) => {
        return response;
      },
      invalidatesTags: (result, error, { loadId }) => [
        { type: 'Loads' as const, id: loadId },
        { type: 'Loads', id: 'LOADS_LIST' },
        { type: 'All-Loads' as const, id: loadId },
        { type: 'All-Loads', id: 'ALL_LOADS_LIST' }
      ]
    }),

    sendEdiMessageUpdate: builder.mutation<
      boolean,
      { stopId: string; ediStopMessageUpdate: EdiStopMessageUpdate }
    >({
      query: (data) => ({
        url: `/stops/${data.stopId}/edi/status`,
        body: data.ediStopMessageUpdate,
        method: 'POST'
      }),
      transformResponse: (response: { status: boolean }) => response.status
    })
  }),
  overrideExisting: false
});

export const {
  useGetCreateLoadConfigQuery,

  useQboCustomerSearchMutation,
  useGetExtractionConfigsQuery,
  usePrefetch: usePrefetchLoadsQuery,
  useAddDocumentMutation,
  useSendEdiMessageUpdateMutation,
  util: loadApiUtil
} = loadApi;
